import { isLeapYear } from '@/utils/isLeapYear';

const NUM_DAYS_IN_MONTHS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export function subtractMonths(dateObj: Date, numMonths: number, shouldModifyOriginalDateObj?: boolean) {
  // Note: this function will fall one day backwards
  // when in doubt. (i.e. may 31st minus 1 month will
  // be april 30th, because april 31st doesn't exist)

  dateObj = shouldModifyOriginalDateObj ? dateObj : new Date(dateObj.getTime());
  let modifiedDayOfMonth = dateObj.getDate();
  let modifiedMonth = dateObj.getMonth() - numMonths;
  let modifiedYear = dateObj.getFullYear();

  if (modifiedMonth < 0) {
    modifiedYear = modifiedYear - 1 - Math.floor(Math.abs(modifiedMonth) / 12);
    modifiedMonth = 12 - (Math.abs(modifiedMonth) % 12);

    if (modifiedMonth === 12) {
      modifiedMonth = 0;
      modifiedYear++;
    }
  }

  const numDaysInMonths = [ ...NUM_DAYS_IN_MONTHS ];

  if (isLeapYear(modifiedYear)) {
    numDaysInMonths[1] = 29;
  }

  const numDaysInMonth = numDaysInMonths[modifiedMonth];

  if (modifiedDayOfMonth > numDaysInMonth) {
    modifiedDayOfMonth = numDaysInMonth;
  }

  const modifiedDate = new Date(modifiedYear, modifiedMonth, modifiedDayOfMonth, 0, 0, 0, 0);

  dateObj.setTime(modifiedDate.getTime());

  return dateObj;
}
